module.exports = __webpack_public_path__ + "static/media/client1.8ad7732b.png";